import React from 'react';
import { Spinner } from 'react-bootstrap';

import RelatorioTable from 'components/Relatorios/shared/RelatorioTable';

import useDecompSecaoParams from 'hooks/Relatorios/Decomp/useDecompSecaoParams';
import { useGetDecompVisaoGeralQuery } from 'services/api/products/relatorios';
import Chart from './Chart';

export default function VisaoGeral() {
  const params = useDecompSecaoParams();

  const { data, isLoading } = useGetDecompVisaoGeralQuery(params);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-3">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!data) {
    return null;
  }

  const columns = ['Série', ...data.periodos];
  const rows = data.series.map((s) => [s.nome, ...s.valores]);

  return (
    <div>
      <Chart data={data} />
      <RelatorioTable titulo={data.titulo} columns={columns} rows={rows} />
    </div>
  );
}
